import { color, textSize, triangle } from 'styles/helpers'

const localesStyles = {
  localesContainer: {
    position: 'absolute',
    top: 0,
    right: 0
  },
  selector: {
    position: 'relative',
    zIndex: 2,
    display: 'block',
    ...textSize(13, 18),
    padding: '0 12px 0 0',
    background: 'transparent',
    border: 'none',
    ...color('textSecondary'),
    appearance: 'none',
    textTransform: 'uppercase'
  },
  selectorArrow: {
    position: 'absolute',
    zIndex: 1,
    display: 'block',
    top: 0,
    right: 0,
    height: 18,
    width: 8,
    pointerEvents: 'none',
    ...triangle(8, 'textSecondary', {
      top: '50%',
      right: 0,
      marginTop: -2,
      transform: 'rotate(180deg)',
      transformOrigin: 'center'
    })
  }
}

export default localesStyles
